import type { Component } from "solid-js";
import compactLogo from "@/assets/compact-light-logo.svg";

export const SplashScreen: Component = () => {
  return (
    <div
      class="
        flex items-center justify-center
        w-full h-screen
        bg-white dark:bg-gray-900
      "
      style={{ animation: "fade-in 0.5s ease-out" }}
    >
      <div class="flex flex-col items-center justify-center gap-6">
        <img
          src={compactLogo}
          alt="Sevedemo logo"
          class="w-32 h-32 md:w-40 md:h-40 object-contain animate-pulse"
        />
        <div class="flex items-center justify-center gap-2">
          <div
            class="w-2 h-2 rounded-full bg-primary animate-bounce"
            style={{ "animation-delay": "0ms", "animation-duration": "1.4s" }}
          />
          <div
            class="w-2 h-2 rounded-full bg-primary animate-bounce"
            style={{ "animation-delay": "200ms", "animation-duration": "1.4s" }}
          />
          <div
            class="w-2 h-2 rounded-full bg-primary animate-bounce"
            style={{ "animation-delay": "400ms", "animation-duration": "1.4s" }}
          />
        </div>
      </div>
    </div>
  );
};
